import { Link } from "react-router-dom";
import { CATEGORY_LABELS } from "../lib/constants";

export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="sticky top-24">
            <div className="rule" />
            <h4 className="eyebrow text-accent mt-3 mb-1">Trending Now</h4>
            <ol className="mt-4">
                {items.map((a, i) => (
                    <li key={a.id} className="border-t border-line">
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-4 py-4"
                        >
                            <span className="font-display text-3xl font-black text-line group-hover:text-accent transition-colors duration-100 leading-none w-10 shrink-0 tabular-nums">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="min-w-0">
                                <span className="eyebrow text-dim">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-display text-[15px] font-bold leading-[1.2] tracking-[-0.015em] mt-1.5 group-hover:text-accent transition-colors duration-100">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-dim py-4 border-t border-line">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
